export default "__VITE_ASSET__27bd1483__"